import React, { PureComponent, Fragment } from 'react'
import { Card, CardText, CardBody, CardTitle } from 'reactstrap'
import ReactTooltip from 'react-tooltip'
import { toMoney } from 'helpers'

class NfceBody  extends PureComponent {

    render() {

        return (
            <Fragment>
                
                {this.props.lista.map((p, index) => {
                        return (
                            <div key={index} className="col col-sm-4 company-card">

                                <Card className="shadow-effect">
                                    <CardBody>
                                        <CardTitle className="company-title">{p.nomeEmpresa}</CardTitle>
                                        <div className="row">
                                            <div className="col">
                                                <CardText data-tip="Notas emitidas + correções mês anterior" data-effect="solid" className="company-values">RECEITA FISCAL:</CardText>
                                            </div>
                                            <div className="col col-5">
                                                <CardText className="company-values">
                                                    {/* {toMoney((p['correcao'] + p['notasEmitidas']).toFixed(2))} */}
                                                    {toMoney(p['receita'].toFixed(2))}
                                                </CardText>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col">
                                                <CardText className="company-values">Venda detalhada:</CardText>
                                            </div>
                                            <div className="col col-5">
                                                <CardText className="company-values">
                                                    {p['vendaDetalhada'] !== 0 ? <span data-emp={p._id} data-detail="venda_detalhada" onClick={this.props.toggleDetail} className="detailable-value">{toMoney(p['vendaDetalhada'].toFixed(2))}</span> : '0,00' }
                                                </CardText>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col">
                                                <CardText className="company-values">Notas emitidas:</CardText>
                                            </div>
                                            <div className="col col-5">
                                                <CardText className="company-values">
                                                    {p['notasEmitidas'] !== 0 ? <span data-emp={p._id} data-detail="notas_emitidas" onClick={this.props.toggleDetail} className="detailable-value">{toMoney(p['notasEmitidas'].toFixed(2))}</span> : '0,00' }
                                                </CardText>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col">
                                                <CardText data-tip="Notas emitidas - venda detalhada" data-effect="solid" className="company-values">Diferença:</CardText>
                                            </div>
                                            <div className="col col-5">
                                                <CardText className="company-values">
                                                    {Math.abs(p['notasEmitidas'] - p['vendaDetalhada']) >= 0.1 ? (
                                                        
                                                        <span 
                                                            data-emp={p._id} 
                                                            data-detail="diferencas" 
                                                            onClick={this.props.toggleDetail} 
                                                            className="detailable-value"
                                                        >
                                                            {toMoney(Math.abs(p['notasEmitidas'] - p['vendaDetalhada']).toFixed(2))}
                                                        </span>
                                                    ) : (
                                                        '0,00'
                                                    )}
                                                </CardText>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col">
                                                <CardText className="company-values">Duplicidades:</CardText>
                                            </div>
                                            <div className="col col-5">
                                                <CardText className="company-values">
                                                    {p['duplicados'] !== 0 ? <span data-emp={p._id} data-detail="duplicidades" onClick={this.props.toggleDetail} className="detailable-value">{toMoney(p['duplicados'].toFixed(2))}</span> : '0,00' }
                                                </CardText>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col">
                                                <CardText className="company-values">NFs Complementares:</CardText>
                                            </div>
                                            <div className="col col-5">
                                                <CardText className="company-values">
                                                    {p['complementar'] !== 0 ? <span data-emp={p._id} data-detail="nfs_complementares" onClick={this.props.toggleDetail} className="detailable-value">{toMoney(p['complementar'].toFixed(2))}</span> : '0,00' }
                                                </CardText>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col">
                                                <CardText className="company-values">Correção mês anterior:</CardText>
                                            </div>
                                            <div className="col col-5">
                                                <CardText className="company-values">
                                                    {p['correcao'] !== 0 ? <span data-emp={p._id} data-detail="correcoes" onClick={this.props.toggleDetail} className="detailable-value">{toMoney(p['correcao'].toFixed(2))}</span> : '0,00' }
                                                </CardText>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col">
                                                <CardText className="company-values">Vendas Rejeitadas::</CardText>
                                            </div>
                                            <div className="col col-5">
                                                <CardText className="company-values">
                                                    {p['vendasRejeitadas'] !== 0 ? <span data-emp={p._id} data-detail="rejeitadas" onClick={this.props.toggleDetail} className="detailable-value">{toMoney(p['vendasRejeitadas'].toFixed(2))}</span> : '0,00' }
                                                </CardText>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col">
                                                <CardText className="company-values">Vendas Sem Número: </CardText>
                                            </div>
                                            <div className="col col-5">
                                                <CardText className="company-values">
                                                    {p['vendasSemNumero'] !== 0 ? <span data-emp={p._id} data-detail="vendas_sem_numero" onClick={this.props.toggleDetail} className="detailable-value">{toMoney(p['vendasSemNumero'].toFixed(2))}</span> : '0,00' }
                                                </CardText>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col">
                                                <CardText className="company-values">Notas Tipo F:</CardText>
                                            </div>
                                            <div className="col col-5">
                                                <CardText className="company-values">
                                                    {p['notasF'] !== 0 ? <span data-emp={p._id} data-detail="notasF" onClick={this.props.toggleDetail} className="detailable-value">{toMoney(p['notasF'].toFixed(2))}</span> : '0,00' }
                                                </CardText>
                                            </div>
                                        </div>
                                        
                                        
                                    </CardBody>
                                </Card>
                                <ReactTooltip />
                            </div>
                        )
                    })}

            </Fragment>
        )

    }
}

export default NfceBody